import React, { useState, Fragment } from 'react';
import { Row, Input, Label, Button, Modal, ModalBody, ModalHeader } from 'reactstrap';
import { Colxx } from '../../../../../../../components/common/CustomBootstrap';
import PropTypes from 'prop-types';
import IntlMessages from '../../../../../../../helpers/IntlMessages';
import { AxiosAPI } from '../../../../../../../helpers/AxiosAPI';
import { putAPI_Update_AddOns_Images } from '../../../../../../../constants/APIs';
import ImageGallery from '../../../../propinfo/gallery/index'
export default function AddonsImagesForm({ images, id }) {
  const [inputFields, setInputFields] = useState(images);
  const [isEditing, setIsEditing] = useState(false);
  const [imageIndex, setImageIndex] = useState(-1);
  const [galleryVisible, setGalleryVisible] = useState(false);
  const handleAddFields = () => {
    const values = [...inputFields];
    values.push({
      url: '',
      displayOrder: 1,
    });
    setInputFields(values);
    setIsEditing(true);
  };

  const handleRemoveFields = index => {
    const values = [...inputFields];
    values.splice(index, 1);
    setInputFields(values);
    setIsEditing(true);
  };

  const handleInputChange = (index, event) => {
    const values = [...inputFields];
    if (event.target.name === 'url') {
      values[index].url = event.target.value;
    } else {
      values[index].displayOrder = event.target.value;
    }

    setInputFields(values);
    setIsEditing(true);
  };
  const togglegallery = (index) => {
    setImageIndex(index)
    setGalleryVisible(!galleryVisible);
  };

  const selectedImage = (image) => {
    const newItems = [...inputFields];
    newItems[imageIndex].url = image.src;
    setInputFields(newItems);
    setIsEditing(true);
  };
  const handleSubmit = e => {
    e.preventDefault();
    const data = { images: [...inputFields], updater: 'admin' };
    AxiosAPI({
      method: 'put',
      url: `${putAPI_Update_AddOns_Images}/${id}`,
      data,
    }).then(() =>
      setTimeout(() => {
        window.location.reload();
      }, 300)
    );
  };
  const ImageGalleryButton = () => {
    return (
      <Row>
        <Colxx xs="12" sm="12" md="12" lg="12" className="mb-4">
          <Row>
            <Colxx xs="12" sm="3" className="mb-1">
              <Modal isOpen={galleryVisible} toggle={togglegallery} style={{ maxWidth: '1000px' }}>
                <ModalHeader toggle={togglegallery}>
                  Select Image or Upload New Image
                </ModalHeader>
                <ModalBody>
                  <ImageGallery selectedImage={selectedImage} togglegallery={togglegallery}
                    hideUserUploads={false} searchText={""} />
                </ModalBody>
              </Modal>
            </Colxx>
          </Row>
        </Colxx>
      </Row>
    );
  };

  return (
    <div>
      <h4>Add-on images</h4>
      {/* <pre>{JSON.stringify(inputFields, null, 2)}</pre> */}
      <Row>
        {inputFields.map((img, index) => (
          <Fragment key={index}>
            <Colxx sm={2} className="md-3">
              <img
                style={{
                  width: '100%',
                  height: '90%',
                }}
                alt="add ons images"
                src={img.url || 'https://via.placeholder.com/150/'}
              />
            </Colxx>
            {/* <Colxx sm={7} className="mb-3">
              <Label>Link</Label>
              <Input
                type="text"
                name="url"
                value={img.url}
                onChange={event => handleInputChange(index, event)}
              />
            </Colxx> */}
            <Colxx sm={2} className="mb-3">
              <Label><IntlMessages id='dashboards.displayOrder' /> </Label>
              <Input
                type="number"
                name="displayOrder"
                min={1}
                value={img.displayOrder}
                onChange={event => handleInputChange(index, event)}
              />
            </Colxx>
            <Colxx sm={1} className="mb-3">
              <Label>Browse</Label>
              <div className="iconsminds-photo" onClick={event => togglegallery(index)}
                style={{ cursor: 'pointer', fontSize: '28px', color: '#73236b' }}
              >

              </div>
            </Colxx>
            <Colxx sm={1} className="mb-3">
              <Label>Remove</Label>
              <div>
                <Button
                  onClick={() => handleRemoveFields(index)}
                  color="secondary"
                  size="xs"
                  outline
                  style={{ margin: '6px' }}
                >
                  -
                </Button>
              </div>
            </Colxx>
          </Fragment>
        ))}
      </Row>
      <Button
        onClick={handleAddFields}
        color="primary"
        size="xs"
        outline
        style={{ margin: '6px' }}
      >
        + Add image
      </Button>
      {isEditing && (
        <Button
          color="secondary"
          outline
          style={{ float: 'right' }}
          onClick={handleSubmit}
        >
          Save images
        </Button>
      )}
      {ImageGalleryButton()}
    </div>
  );
}

AddonsImagesForm.propTypes = {
  id: PropTypes.string.isRequired,
  images: PropTypes.arrayOf(
    PropTypes.shape({
      url: PropTypes.string.isRequired,
      displayOrder: PropTypes.number.isRequired,
    })
  ).isRequired,
};
